import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormHelperText,
  Grid,
  GridList,
  GridListTile,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { EventEmitterService } from '../../services/EventEmitterService'
import { FirebaseConfigKey, FirebaseService } from '../../services/FirebaseService'
import { isOver18, textToConst, prange, isOver16 } from '../../services/utils'
import { LabeledRadioButton, YesNoRadioButton } from '../Core/Buttons/ControlledRadioButtons'
import NewFillButton from '../Core/NewFillButton'
import DeleteIcon from '@material-ui/icons/Delete'
import { ReactComponent as AddSvg } from '../../assets/add.svg'
import { ReactComponent as HelmetSvg } from '../../assets/helmet.svg'
import {
  statesWithoutEducationDiscount,
  statesWithResidenceInsuranceFactor,
  stateWithoutEducationDiscount,
  VIOLATIONS,
  stateWithActiveMilitaryDiscount,
} from '../../Constants'
import { FlatFormSubmitButton } from '../Core/FlatFormSubmitButton'
import { SessionContextStore } from '../../context/SessionContext'
import { SkyInformationPopover } from '../Core/Popover/SkyPopover'
import { isMobile, BrowserView, MobileView } from 'react-device-detect'
import { GlobalTextField } from '../Core/Input/ControlledTextField'
import { StatesContextStore } from '../../context/StatesContext'

export const OperatorForm = ({ defaultValues = {}, SAVE_EVENT_KEY, onSave, motorcycles, diableUserDetails, special }) => {
  const { register, watch, triggerValidation, setValue, errors, control, getValues, handleSubmit } = useForm({
    defaultValues: defaultValues,
    mode: 'onChange',
  })
  const [operate, setOperates] = React.useState(
    (defaultValues.user_vehicle_details && defaultValues.user_vehicle_details.map(v => v.id)) || []
  )
  const [populateOwnerDetails, setPopulateOwnerDetails] = React.useState(true)
  const sessionContext = React.useContext(SessionContextStore)
  const [isLicenseEndorsedDisabled, setIsLicenseEndorsedDisabled] = useState(false)
  const state = sessionContext.user.administrativeDivision
  const statesContext = useContext(StatesContextStore)
  const accidentHistoryWatch = watch('recent_accident')
  const [isEducationFactorDisabled, setIsEducationFactorDisabled] = useState(false)

  const onFormSubmit = async data => {
    let valid = await triggerValidation()

    if (!valid) return

    data.operates = operate
    data.license_state = defaultValues.license_state
    data.driver_license = defaultValues.driver_license
    data.is_owner = populateOwnerDetails && special

    onSave(data)
  }

  const checkIfAllVehiclesSnwType = () => {
    let userVehicles = sessionContext.user.userVehicles
    let isAllVehiclesSnw = false
    if (!!userVehicles && userVehicles.length > 0) {
      isAllVehiclesSnw = userVehicles.every(vehicle => vehicle.type === 'snw')
    }
    setIsLicenseEndorsedDisabled(isAllVehiclesSnw)
  }

  React.useEffect(() => {
    register('id', '')
    let id = EventEmitterService.subscribe(SAVE_EVENT_KEY, async () => {
      onFormSubmit()
    })
    if (operate.length == 0) {
      setOperates(motorcycles.map(m => m.id))
    }
    checkIfAllVehiclesSnwType()
    setIsEducationFactorDisabled(stateWithoutEducationDiscount.includes(state))
    return function cleanup() {
      EventEmitterService.unsubscribe(SAVE_EVENT_KEY, id)
    }
  }, [])

  return (
    <form className="full-width" onSubmit={handleSubmit(onFormSubmit)}>
      <FlexView vAlignContent={'center'} className="margin-bottom-basic">
        <HelmetSvg className="large-icon margin-right-6" />
        <div className="text-title bold black">Rider Details</div>
      </FlexView>
      {special && (
        <FormControlLabel
          className="margin-bottom-small"
          control={
            <Checkbox
              checked={populateOwnerDetails}
              color="primary"
              onChange={() => {
                if (!populateOwnerDetails) {
                  setValue('first_name', sessionContext.user.firstName)
                  setValue('last_name', sessionContext.user.lastName)
                  setValue('date_of_birth', sessionContext.user.dateOfBirth)
                } else {
                  setValue('first_name', '')
                  setValue('last_name', '')
                  setValue('date_of_birth', null)
                }
                setPopulateOwnerDetails(!populateOwnerDetails)
              }}
            />
          }
          label="The owner is also a rider"
        />
      )}

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <GlobalTextField
            shrink={!!watch('first_name')}
            disabled={diableUserDetails}
            fullWidth
            label="First name"
            name="first_name"
            inputRef={register({ required: true })}
            register={register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={errors}
            helperText={!!errors.first_name && 'Required'}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <GlobalTextField
            shrink={!!watch('last_name')}
            disabled={diableUserDetails}
            fullWidth
            label="Last name"
            name="last_name"
            inputRef={register({ required: true })}
            register={register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={errors}
            helperText={!!errors.last_name && 'Required'}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Controller
            as={
              <DatePicker
                InputLabelProps={{ className: 'avenir-book' }}
                className="avenir-book"
                disabled={diableUserDetails}
                disableFuture
                fullWidth
                openTo="year"
                views={['year', 'month', 'date']}
                label={'Date of Birth'}
                error={!!errors.date_of_birth}
                inputVariant="outlined"
                helperText={errors.date_of_birth ? (special ? 'Must be 18 or older' : 'Must be 16 or older') : ''}
                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
              />
            }
            onChange={date => {
              setValue('date_of_birth', new Date(date[0]))
              return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
            }}
            rules={{ validate: tim => (tim && special ? isOver18(tim) : isOver16(tim)), required: true }}
            name="date_of_birth"
            value={watch('date_of_birth')}
            defaultValue={null}
            control={control}
          />
        </Grid>
      </Grid>
      <br />
      <Divider />
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          {/* <div className="text-body black margin-bottom-small margin-top-small">Riding experience</div> */}
          <Controller
            control={control}
            rules={{ validate: x => x && x != 'default', required: true }}
            name="experience_years"
            defaultValue={defaultValues.experience_years || 'default'}
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!errors.experience_years}
                variant="outlined"
                fullWidth
                label="Years of riding experience"
                select
              >
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text avenir-book">Riding experience</div>
                </MenuItem>
                {prange(1, 6, 1).map(val => (
                  <MenuItem value={val.toString()}>{val}</MenuItem>
                ))}
                <MenuItem value={'6'}>6+</MenuItem>
              </TextField>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          {/* <div className="text-body black margin-bottom-small margin-top-small">Marital status</div> */}
          <Controller
            control={control}
            rules={{ validate: x => x && x != 'default', required: true }}
            name="is_married"
            defaultValue={defaultValues.is_married ? defaultValues.is_married.toString() : 'default'}
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!errors.is_married}
                variant="outlined"
                fullWidth
                label="Marital status"
                select
              >
                <MenuItem disabled value={'default'}>
                  <div className="placeholder-text avenir-book">Marital status</div>
                </MenuItem>
                <MenuItem value={'false'}>Single</MenuItem>
                <MenuItem value={'true'}>Married</MenuItem>
              </TextField>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          {!isEducationFactorDisabled && (
            <Controller
              control={control}
              rules={{ validate: x => x && x != 'default', required: !isEducationFactorDisabled }}
              name="education_level"
              defaultValue={defaultValues.education_level || 'default'}
              as={
                <TextField
                  InputLabelProps={{ className: 'avenir-book' }}
                  error={!!errors.education_level}
                  variant="outlined"
                  fullWidth
                  label="Highest level of education"
                  select
                >
                  <MenuItem disabled value={'default'}>
                    <div className="placeholder-text avenir-book">Highest level of education</div>
                  </MenuItem>
                  <MenuItem value={'NoHSDiplomaOrGED'}>No HS diploma or GED </MenuItem>
                  <MenuItem value={'HSDiplomaOrGED'}>HS diploma or GED </MenuItem>
                  <MenuItem value={'VocationalOrTradeSchool'}>Vocational or trade school</MenuItem>
                  <MenuItem value={'CompletedSomeCollege'}>Completed some college</MenuItem>
                  <MenuItem value={'CurrentlyAttendingCollege'}>Currently attending college</MenuItem>
                  <MenuItem value={'CollegeDegree'}>College degree</MenuItem>
                  <MenuItem value={'GraduateWorkOrDegree'}>Graduate work or degree</MenuItem>
                </TextField>
              }
            />
          )}
        </Grid>
      </Grid>

      {!isLicenseEndorsedDisabled && (
        <YesNoRadioButton
          label={'Is your driver’s license endorsed for motorcycle use?'}
          name="license_endorsed_for_motorcycle"
          discount
          defaultValue={defaultValues['license_endorsed_for_motorcycle']}
          register={register}
          control={control}
          errors={errors}
          watch={watch}
          tooltip={
            <SkyInformationPopover>
              <div className="text-small avenir-book">
                {
                  'Select Yes, if this driver currently has a valid motorcycle license or motorcycle endorsement on their driver’s license We may request a copy of the license if you purchase a policy.'
                }
              </div>
            </SkyInformationPopover>
          }
        />
      )}

      <YesNoRadioButton
        label={'Have you taken a safety education course?'}
        discount
        name="education_course"
        defaultValue={defaultValues['education_course']}
        register={register}
        control={control}
        errors={errors}
        watch={watch}
        tooltip={
          <SkyInformationPopover eventId={'safety-education'}>
            <div className="text-small avenir-book">
              Select 'Yes' if you have completed, within the past 3 years, a safety course specifically designed for motorcycle, ATV or
              snowmobile operators
              {state === 'VA'
                ? '; or a mature driver motor vehicle crash prevention course approved by the Virginia Department of Motor Vehicles.'
                : '.'}
            </div>
          </SkyInformationPopover>
        }
      />
      {statesContext.residence_insurance_factor_states.includes(state) ? (
        <YesNoRadioButton
          discount
          label={'Do you own an insurance for your principal residence?'}
          name="residence_insurance"
          defaultValue={defaultValues['residence_insurance']}
          register={register}
          control={control}
          errors={errors}
          watch={watch}
          tooltip={
            <SkyInformationPopover eventId={'residence-insurance'}>
              <div className="text-small avenir-book">
                {
                  'Select Yes if you or your spouse are listed as the named insured under a homeowner, condominium owner, renters, or manufactured home owners policy for your principal residence.'
                }
              </div>
            </SkyInformationPopover>
          }
        />
      ) : (
        <YesNoRadioButton
          discount
          label={'Do you own a home?'}
          name="own_home"
          defaultValue={defaultValues['own_home']}
          register={register}
          control={control}
          errors={errors}
          watch={watch}
        />
      )}

      {stateWithActiveMilitaryDiscount.includes(state) && (
        <YesNoRadioButton
          discount
          label={'Are you an active military personnel?'}
          name="active_military"
          defaultValue={defaultValues['active_military']}
          register={register}
          control={control}
          errors={errors}
          watch={watch}
          tooltip={
            <SkyInformationPopover eventId={'active_military'}>
              <div className="text-small avenir-book">
                {
                  'To qualify for this discount, you must be an Active Military Personnel (AMP) based in Louisiana, serving full-time in the Army, Navy, Marine Corps, Air Force, Reserves, National Guard, or Coast Guard. The discount applies to vehicle liability insurance policies and includes coverage for all vehicles owned by the AMP. You are eligible for the discount as long as you maintain your active military status.'
                }
              </div>
            </SkyInformationPopover>
          }
        />
      )}

      <div className="text-body black margin-top-basic">Please check the motorcycle(s) you ride</div>
      {motorcycles.map((m, i) => (
        <FlexView key={i} vAlignContent={'center'}>
          <FormControlLabel
            value={m.id}
            checked={operate.filter(f => f == m.id).length > 0}
            onChange={e => {
              let index = operate.findIndex(f => f == m.id)
              if (index == -1) setOperates([...operate, e.target.value])
              else setOperates(operate.filter(x => x != e.target.value))
            }}
            control={<Checkbox color="primary" />}
          />
          {m.new_vehicle_req_details == '' ? (
            <div className="text-body black">
              {m.make} {m.model} {m.year}
            </div>
          ) : (
            <div className="text-body black">{m.new_vehicle_req_details}</div>
          )}
        </FlexView>
      ))}

      <Divider />
      <div className="text-body bold black margin-bottom-basic">
        Riding History
        <SkyInformationPopover>
          <div className="text-small avenir-book">
            {
              <>
                <span> Important Disclosure Notice: 'Past Posting':</span>
                <br></br>
                <span>
                  'Past posting' refers to the act of seeking insurance after an incident without prior coverage, or creating the appearance
                  of coverage during the incident through the manipulation of documentation. This constitutes insurance fraud, which is
                  unlawful and may lead to financial penalties and potential incarceration. Furthermore, insurance fraud contributes to
                  increased premiums for all policyholders. We strongly recommend providing accurate and honest information in your
                  disclosures to avoid potential legal repercussions and mitigate elevated insurance costs for all.
                </span>
              </>
            }
          </div>
        </SkyInformationPopover>
      </div>
      <YesNoRadioButton
        label={'Have you had any violations or at-fault accidents causing more than $1000 damage in the past 3 years?'}
        name="recent_accident"
        defaultValue={defaultValues['recent_accident']}
        register={register}
        control={control}
        errors={errors}
        watch={watch}
      />
      {accidentHistoryWatch == 'yes' && (
        <>
          <div className="text-small black margin-bottom-basic">Please add the violations and the date each occured:</div>
          <ViolationList register={register} control={control} errors={errors} setValue={setValue} />
        </>
      )}
      <FlexView hAlignContent={'center'} className="margin-top-basic">
        <FlatFormSubmitButton>Save</FlatFormSubmitButton>
      </FlexView>
    </form>
  )
}

export const ViolationList = ({ register, control, errors, setValue }) => {
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: 'insured_person_driving_history',
  })

  React.useEffect(() => {
    if (fields.length == 0) append({ violation_date: new Date() })
  }, [])

  const today = new Date()
  return (
    <>
      {fields.map((item, index) => (
        <FlexView key={item.id} className="margin-bottom-basic">
          {/* <TextField variant='outlined' label={'description'} fullWidth inputRef={register}  /> */}
          <div className={`full-width ${isMobile ? 'text-overflow-elipsis-small' : ''}`}>
            <Controller
              control={control}
              rules={{ validate: x => x && x != 'none' }}
              name={`insured_person_driving_history[${index}].violation_description`}
              defaultValue={item.violation_description ? item.violation_description : 'none'}
              as={
                <Select fullWidth error={!!errors[`insured_person_driving_history[${index}].violation_description`]} variant="outlined">
                  <MenuItem disabled value={'none'}>
                    Violation Description
                  </MenuItem>
                  {VIOLATIONS.map((violation, index) => (
                    <MenuItem key={index} value={textToConst(violation)}>
                      {violation}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            {errors.insured_person_driving_history &&
              errors.insured_person_driving_history[index] &&
              errors.insured_person_driving_history[index]['violation_description'] && (
                <div className="text-body margin-top-small red">required</div>
              )}
          </div>
          <Controller
            as={
              <DatePicker
                disableFuture
                className="margin-left-basic"
                fullWidth
                minDate={new Date(today.getUTCFullYear() - 3, today.getUTCMonth(), today.getUTCDate())}
                openTo="year"
                views={['year', 'month', 'date']}
                label={'Date'}
                error={!!errors[`insured_person_driving_history[${index}].violation_date`]}
                inputVariant="outlined"
                helperText={!!errors[`insured_person_driving_history[${index}].violation_date`] && 'required'}
                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
              />
            }
            onChange={date => {
              setValue(`insured_person_driving_history[${index}].violation_date`, new Date(date[0]))
              return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
            }}
            name={`insured_person_driving_history[${index}].violation_date`}
            value={item.violation_date}
            defaultValue={item.violation_date}
            control={control}
          />
          {index >= 0 && (
            <IconButton onClick={() => remove(index)}>
              <DeleteIcon className="backbuttongray" />
            </IconButton>
          )}
        </FlexView>
      ))}
      <FlexView vAlignContent={'center'} className="clickable fit-content" onClick={() => append({ violation_date: new Date() })}>
        <AddSvg />
        <div className="text-body black margin-left-6">Add violation</div>
      </FlexView>
    </>
  )
}
